import { render, staticRenderFns } from "./PaginaImportaTracciatoZip.vue?vue&type=template&id=bc6b11b2"
import script from "./PaginaImportaTracciatoZip.vue?vue&type=script&lang=js"
export * from "./PaginaImportaTracciatoZip.vue?vue&type=script&lang=js"
import style0 from "./PaginaImportaTracciatoZip.vue?vue&type=style&index=0&id=bc6b11b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports